import { z } from "zod";
import { passwordValidator } from "../../../lib/validator/password";

export const CreatePasswordFormSchema = z.object({
  password: passwordValidator,
});

export type CreatePasswordFormSchemaType = z.infer<
  typeof CreatePasswordFormSchema
>;

export interface CreatePasswordPayload {
  email: string;
  password: string;
  otpToken: string;
}
